import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import DefaultLayout from "layouts/Default";
import {wrapper} from "lib/store";
import {useRouter} from "next/router";
import {getProductCategories} from "lib/services/product";
import CategoryCard from "components/cards/CategoryCard";
import ItemGrid from "components/blocks/ItemGrid";
import React, {useEffect} from "react";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
  const {
    query,locale,router
  } = context
  const {
    country,
    region,
    city,
    languages,
    latitude, longitude,page = 1,
    locationTypes = [],
    amenities = [],
    openNow = false,
    sort = {},
  } = query
  const filter = {
    latitude: latitude,
    longitude: longitude,
    locationTypes,
    amenities,
    openNow
  }
  const categories = await getProductCategories()

  return {
    props: {
      categories,
      ...(await serverSideTranslations(locale, ['home', 'common']))
    }
  }
})

export default function Products(props) {
  const {
    categories
  } = props

  const router = useRouter()
  const { t } = useTranslation()
  useEffect(() => {
    // console.log('categ: ', JSON.stringify(categories))
  }, [])

  return (
    <Wrapper>
      <Container>
        <ItemGrid
            t={t}
          title={t('home:product_browsebycategory')} items={categories}
          render={item => (
            <CategoryCard categoryLevel={1} key={item.slug} data={item} baseUrl={'/products'} cardType={'product'} t={t} />
          )}
        />
      </Container>
      {
        categories.map(cat => (
          <Container key={cat.slug} className={"mt-16"}>
            <ItemGrid
                t={t}
              title={t(`home:${cat.slug}`)} href={`/products/${cat.slug}`} items={cat.subcategories && cat.subcategories.length >= 4 ? cat.subcategories.slice(0, 4) : cat.subcategories}
              render={item => (
                <CategoryCard key={item.slug} categoryLevel={2} data={item} baseUrl={'/products'} cardType={'product'} t={t} />
              )}
            />
          </Container>
        ))
      }
    </Wrapper>
  )
}

Products.getLayout = function getLayout(page) {
  return (
    <DefaultLayout>
      {page}
    </DefaultLayout>
  )
}
